import { GET_PAYMENT_DETAILS } from "../components/action-types"


const getPaymentDetailsReducer = (state = [], action) => {
    switch (action.type) {
        case (GET_PAYMENT_DETAILS):
            return state = action.payload
        default:
            return state
    }
}

export default getPaymentDetailsReducer;